'use client';

import { useSyncExternalStore } from 'react';

import { DEV_TARGET_URL } from '@/dev/target-url';

const isDev = process.env.NODE_ENV !== 'production';

function detectEmbeddedParentUrl(): string {
  if (typeof window === 'undefined') return '';
  const detected = window.location.href.split('/__partners-feedback')[0];
  if (detected && detected !== window.location.href) {
    return detected;
  }
  return '';
}

export function useTargetUrl(initialTargetUrl?: string): string {
  return useSyncExternalStore(
    () => () => {},
    () =>
      detectEmbeddedParentUrl() ||
      initialTargetUrl ||
      (isDev ? DEV_TARGET_URL : ''),
    () => initialTargetUrl ?? (isDev ? DEV_TARGET_URL : ''),
  );
}
